import {SQLLanguages} from "@/formatters/sql";

export interface sqlFormatterBlock{
    text: string;
    sqlLanguage: SQLLanguages;
    keywordCase: string;
    dataTypeCase: string;
}


export enum ConversionDataTypes{
    JSON =  "json",
    XML = "xml",
    YAML = "yaml",
    CSV = "csv"
}

export interface dataConverterBlock{
    originalText: string;
    JSONTruth: string;
    originalTextType: ConversionDataTypes;
    convertedText: string;
    convertedTextType: ConversionDataTypes;
}
